import { PretestSingular } from 'api/pretestApi';
import { FC, useRef, useState } from 'react';
import { answers as answersPretest } from 'utils/answers';
import { ensure } from 'utils/validation';
import { PretestManual } from './PretestManual';
import { PretestSummary } from './PretestSummary';
import { PretestTest } from './pretest';
import { PretestSwitchCases } from './types';
import { Beforeunload } from 'react-beforeunload';

interface PretestProps {
  onRouteTo: () => void;
}

export const Pretest: FC<PretestProps> = ({ onRouteTo }) => {
  const result = useRef(0);

  const [route, setRoute] = useState(PretestSwitchCases.instruction);
  const routeTo = (name: PretestSwitchCases) => {
    setRoute(name);
  };

  const processPreTestResult = (answers: PretestSingular[]) => {
    result.current = answers.reduce((pretestResult, answer) => {
      return (pretestResult += ensure(
        answersPretest.find((element) => element.id === answer.answer)
      ).score);
    }, 0);

    return routeTo(PretestSwitchCases.summary);
  };

  switch (route) {
    case PretestSwitchCases.instruction:
      return (
        <PretestManual
          routeTo={() => {
            routeTo(PretestSwitchCases.pretest);
          }}
        />
      );
    case PretestSwitchCases.pretest:
      return (
        <Beforeunload onBeforeunload={(event) => event.preventDefault()}>
          <PretestTest returnData={processPreTestResult} />
        </Beforeunload>
      );
    case PretestSwitchCases.summary:
      return (
        <Beforeunload onBeforeunload={(event) => event.preventDefault()}>
          <PretestSummary
            pretestResult={result.current}
            routeTo={() => onRouteTo()}
          />
        </Beforeunload>
      );

    default:
      return null;
  }
};
